export default __webpack_public_path__ + "images/09a9ec87365caff3103dc46575441835-YGP_citybrowseheader_SF_791x488px@2x.webp";